<template>
  <div class="Good" v-if="Object.keys(good).length > 0">
    <div class="goodBox">
      <div class="imgbox" @click="goGoodsDetail(good.goodsId)">
        <el-image style="width: 100%; height: 100%" :src="good.goodsThumbnail" fit="cover"></el-image>
      </div>
      <div class="price">{{getprice}}</div>
      <div class="name" title="查看详情" @click="goGoodsDetail(good.goodsId)">{{ good.goodsName }}</div>
      <div class="spanItem">
        <span class="date">{{ good.createTime }}</span>
        <!-- 分辨率 -->
        <span class="tag1" v-show="good.goodsCategory < 3">分辨率：{{ good.productDistinguishability }}</span>
        <!-- 云量 -->
        <span class="tag2" v-show="good.goodsCategory < 3">云量：{{ good.cloudCover }}</span>
        <span class="command">{{ good.commentNum }}<span>评价</span></span>
      </div>
      <!-- 查看详情 -->
      <button @click="goGoodsDetail(good.goodsId)">查看详情</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Good",
  props: {
    good: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    getprice() {
      if (this.good.goodsPriceType === 1) {
        if (this.good.goodsPrice > 0) {
          return '￥' + this.good.goodsPrice
        }else {
          return '免费'
        }
      }else if (this.good.goodsPriceType === 2) {
        return '面议'
      }else {
        return '免费'
      }
    }
  },
  methods: {
    // 查看详情
    goGoodsDetail(id){
      this.$router.push({
          path: "/shopDetail",
          query: {
            goodsId: id
          }
        });
    },
    buy(id) {

      if (!this.$store.state.user.userInfo.id) {
          this.noLogin()
        } else {
          let sendData = {"buyType":1,"itemParams":[{"goodsId":id,"number":1}]};
          this.$http.post(this.$const.RemoteSensingMall.shoppingCartAddOrder,sendData)
            .then((res) => {
              // console.log("立即购买:", res);
              if (res.code == 200) {
                this.$router.push({
                  path: "/confirmPay",
                  query: { N: res.data }
                });
              } else {
                this.$message.error(this.$PubText.getInfoFail);
              }
            })
            .catch((error) => {
              this.$message.error(this.$PubText.InterfaceFail);
            });
        }
      // this.$router.push({ path: '/buyerCenter' })
    },
    // 未登录时需登录提示
    noLogin() {
        this.$confirm("此操作需要登录, 是否跳转登录页面?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            this.$router.push({ path: `/login?redirect=${this.$route.fullPath}` });
          })
          .catch(() => {});
      },
  }
}
</script>

<style scoped lang="scss">
.Good {
  width: 25%;
  height: 360px;
  padding: 10px;

  .goodBox {
    box-shadow: 0px 2px 4px #acacac;
    transition: all .5s;

    .imgbox {
      width: 100%;
      height: 200px;
      overflow: hidden;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
        transition: all .5s;

        &:hover {
          transform: scale(1.1);
        }
      }
    }

    .price,
    .name,
    .spanItem {
      padding: 5px;
    }

    .name {
      cursor: pointer;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .price {
      color: #d14d85;
      font-size: 16px;
      font-weight: 600;
    }

    .spanItem {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .date,
      .tag1,
      .tag2 {
        display: inline-block;
        font-size: 12px;
        color: #9a9a9a;
      }

      .date {
        width: 70px;
      }

      .tag1 {
        margin: 0 3px;
      }

      .tag1,
      .tag2 {
        padding: 3px;
        text-align: center;
        border: 1px solid #eaeaea;
        border-radius: 5px;
      }

      span.command {
        flex: auto;
        color: #3868e9;
        text-align: end;
        font-size: 13px;

        span {
          color: #666666;
        }
      }
    }

    button {
      width: 100%;
      height: 40px;
      font-size: 16px;
      font-weight: 600;
      background: #3868e9;
      color: white;
      margin-top: 5px;
      text-align: center;
      cursor: pointer;
    }

    &:hover {
      box-shadow: 0px 5px 7px #acacac;
    }
  }
}
</style>
